<template>
<div class="investment-wizard-wrapper">
  <div class="investment-wizard" v-if="!finished">
    <div class="header">
      Completa tu inversión
    </div>
    <div class="subheader">
      Ya estás muy cerca en convertirte en socio de tu restaurante favorito
    </div>
    <div class="content-wrapper">
      <div class="form-wrapper">
        <BasicData
          :class="{ 'active-special': currentStep === 1 }"
          @next="currentStep++"
          @openStep="currentStep = 1" />
        <AddressData
          :class="{ active: currentStep === 2 }"
          @next="currentStep++"
          @openStep="currentStep = 2" />
        <AdditionalData
          :class="{ active: currentStep === 3 }"
          @next="currentStep++"
          @openStep="currentStep = 3" />
        <IDFile
          :class="{ active: currentStep === 4 }"
          @next="currentStep++"
          @openStep="currentStep = 4" />
        <AddressFile
          :class="{ active: currentStep === 5 }"
          @next="currentStep++"
          @openStep="currentStep = 5" />
        <Final :class="{ active: currentStep === 6 }" @finished="finished = true" />
      </div>
      <div class="investment-info">
        <div class="project-image" :style="{ backgroundImage: `url(${project.mainImageUrl})`}"></div>
        <div class="project-title">{{ project.name }}</div>
        <div class="project-location">{{ project.location }}</div>
        <div class="info-header">Tu inversión</div>
        <div class="quantity">
          {{ formatMoney(investmentAmount) }}
        </div>
        <div class="name">
          Inversión total
        </div>
        <div class="investment-bonus" v-if="user.referralBalance > 0">
          <div class="bonus-title">
            Saldo Flagship
          </div>
          <div class="bonus-quantity">
            -{{ formatMoney(user.referralBalance) }}
          </div>
          <div class="bonus-title">
            Total a pagar
          </div>
          <div class="bonus-quantity">
            {{ formatMoney(investmentAmount - user.referralBalance) }}
          </div>
        </div>
        <div class="quantity">
          SPEI
        </div>
        <div class="name">
          Método de pago
        </div>
        <div class="quantity">
          Enero 2021*
        </div>
        <div class="name">
          Fecha de pago
        </div>
        <div class="payment-note">
          *NOTA: El cobro de tu inversión se llevará a cabo al finalizar el periodo de recaudación y
          únicamente si se logra llegar a la meta definida por el restaurante. Al término de la
          campaña recibirás en tu correo electrónico las instrucciones para realizar la
          transferencia bancaria por SPEI.
        </div>
      </div>
    </div>
  </div>
  <div class="investment-wizard" v-else>
    <div class="header">
      ¡MUCHAS FELICIDADES!
    </div>
    <div class="subtitle">
      Te damos la bienvenida a la familia Flagship
    </div>
    <div class="subheader">
      No olvides que para que tu inversión quede registrada será validada por nuestros ejecutivos
      y deberás realizar la transferencia en tiempo y forma al finalizar la campaña.
    </div>
    <div class="subheader">
      <div class="button" @click="$router.push('/portfolio')">Ver portafólio</div>
    </div>
    <div class="referral-window">
      <div class="referral-title">
        ¿Te gustaría ganar una bonificación para tu siguiente inversión?
      </div>
      <div class="referral-description">
        Recibe $500 por cada amigo que haga su primera inversión en Flagship con tu código. ¡Ellos
        también recibirán $500 de bonificación en su inversión!
      </div>
      <div class="referral-action">
        <div class="referral-button" @click="$router.push('/referral')">
          Conoce más
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BasicData from '@/components/investment-forms/BasicData.vue';
import AddressData from '@/components/investment-forms/AddressData.vue';
import AdditionalData from '@/components/investment-forms/AdditionalData.vue';
import IDFile from '@/components/investment-forms/IDFile.vue';
import AddressFile from '@/components/investment-forms/AddressFile.vue';
import Final from '@/components/investment-forms/Final.vue';
import formatMixin from '@/mixins/formatMixin';

export default {
  data() {
    return {
      investmentAmount: 0,
      currentStep: 1,
      finished: false,
    };
  },
  mixins: [formatMixin],
  components: {
    BasicData,
    AddressData,
    AdditionalData,
    IDFile,
    AddressFile,
    Final,
  },
  methods: {
    ...mapActions('project', [
      'getProject',
    ]),
    ...mapActions('user', [
      'getUser',
    ]),
  },
  computed: {
    ...mapState('project', [
      'project',
    ]),
    ...mapState('user', [
      'user',
    ]),
  },
  async mounted() {
    const projectId = parseInt(this.$route.params.projectId, 10);
    this.investmentAmount = parseInt(this.$route.query.investment, 10);
    await this.getProject(projectId);
    await this.getUser();
  },
};
</script>

<style lang="scss" scoped>
.investment-wizard-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #fafcfe;
  font-family: 'Inter', sans-serif;
}
.investment-wizard {
  width: 1000px;
  margin: 110px 0 80px 0;
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.header {
  text-align: center;
  font-weight: bold;
  font-size: 34px;
}
.subtitle {
  font-weight: bold;
  margin: 24px 0 15px 0;
  text-align: center;
}
.subheader {
  text-align: center;
  font-size: 18px;
  margin-top: 16px;
  line-height: 1.5rem;
}
.content-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.form-wrapper {
  width: 64%;
}
.investment-form {
  max-height: 46px;
  overflow-y: hidden;
  transition: max-height 1s;

  & + .investment-form {
    margin-top: 20px;
  }
}
.active {
  max-height: 1000px !important;
}
.active-special {
  max-height: 1000px !important;
  overflow-y: visible !important;
}
.investment-info {
  width: 31.5%;
}
.project-image {
  width: 100%;
  height: 90px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
}
.project-title {
  font-weight: bold;
  font-size: 28px;
  width: 100%;
  margin-top: 16px;
}
.project-location {
  color: rgb(104, 104, 104);
  margin-top: 8px;
  width: 100%;
}
.payment-note {
  margin-top: 30px;
  color: rgb(104, 104, 104);
  line-height: 1.2rem;
}
.info-header {
  font-weight: bold;
  font-size: 20px;
  margin-top: 28px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 15px;
}
.quantity {
  font-size: 24px;
  font-weight: bold;
}
.name {
  font-size: 16px;
  color: rgb(104, 104, 104);;
  margin-top: 5px;
  margin-bottom: 15px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  width: min-content;
  white-space: nowrap;
  margin: 0 auto;
  margin-top: 20px;
}
.investment-bonus {
  background-color: #e6f5ee;
  margin-bottom: 20px;
  padding: 14px;
  border-radius: 4px;
}
.bonus-quantity {
  margin-top: 8px;
  font-size: 24px;
  & + .bonus-title {
    margin-top: 14px;
  }
}
.referral-window {
  width: 100%;
  padding: 30px 25px;
  border-radius: 8px;
  background-color: #e6f5ee;
  color: black;
  margin-top: 50px;
}
.referral-title {
  font-size: 24px;
  font-weight: bolder;
  margin-bottom: 16px;
}
.referral-description {
  font-size: 16px;
  line-height: 24px;
}
.referral-action {
  margin-top: 20px;
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.referral-button {
  background-color: #3fc67d;
  color: white;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  width: min-content;
  white-space: nowrap;
}
@media only screen and (max-width: 900px) {
  .investment-info {
    display: none;
  }
  .form-wrapper {
    width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  /deep/ .label--half {
    width: 100%;
  }
  /deep/ .id-data {
    width: 100%;
  }
  /deep/ .id-upload {
    margin: 30px 0;
    width: 100%;
  }
}
</style>
